import { useState, useEffect } from "react";

const useVersionCheck = () => {
    const [versionMessage, setVersionMessage] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetch("/version.txt")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch Yiggy version");
                }
                return response.text();
            })
            .then((currentVersion) => {
                const localVersion = localStorage.getItem("app_version");

                if (localVersion !== currentVersion) {
                    localStorage.setItem("app_version", currentVersion);
                    setVersionMessage("Yiggy has been updated! Refreshing...");
                    setOpen(true);
                    setTimeout(() => window.location.reload(true), 2000);
                }
            })
            .catch((error) => {
                setVersionMessage("Error checking version. Try again later.");
                setOpen(true);
                console.error("Error checking Yiggy version:", error);
            });
    }, []);

    return { versionMessage, open, setOpen };
};

export default useVersionCheck;